import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';

import {
  NavigationItem,
  navigationItemsNoPatient,
} from '../../models/navigation-item-model';
import { classes, pages } from '../../shared/labels';
import { Faq, FaqQuestion, mockedFaqs } from '../../models/faq-model-data';
import { FormsModule } from '@angular/forms';
import { LabelService } from '../../services/label.service';
import { GmailService } from '../../services/gmail.service';
import { ErrorPanelService } from '../../services/error-panel.service';
import { ViewportScroller } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-faq-page',
  standalone: true,
  imports: [SharedModule, FormsModule],
  templateUrl: './faq-page.component.html',
  styleUrl: './faq-page.component.scss',
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate(
          '200ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
      transition(':leave', [
        animate(
          '200ms ease-in',
          style({ opacity: 0, transform: 'translateY(-10px)' })
        ),
      ]),
    ]),
  ],
})
export class FaqPageComponent implements OnInit {
  navigationItems: NavigationItem[] = navigationItemsNoPatient;

  faqs: Faq[] = [];
  showContactUsPanel: boolean = false;
  messageText: string = '';

  constructor(
    public labelService: LabelService,
    private gmailService: GmailService,
    private errorPanelService: ErrorPanelService,
    private router: Router,
    private route: ActivatedRoute,
    private viewportScroller: ViewportScroller
  ) {}

  ngOnInit(): void {
    this.getFaqs();
    this.handleRouteParams();
  }

  private handleRouteParams(): void {
    this.route.fragment.subscribe((fragment) => {
      if (!fragment) return;

      const [category, question] = fragment.split('--');

      if (category) {
        const faq = this.faqs.find(
          (f) => this.createSlug(f.category) === category
        );
        if (faq) {
          faq.selected = true;

          if (question) {
            const faqQuestion = faq.questions.find(
              (q) => this.createSlug(q.question) === question
            );
            if (faqQuestion) {
              faqQuestion.selected = true;
              setTimeout(() => {
                const elementId = `${this.createSlug(faq.category)}--${this.createSlug(faqQuestion.question)}`;
                const element = document.getElementById(elementId);
                if (element) {
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
                }
              }, 100);
            }
          }
        }
      }
    });
  }

  createSlug(text: string): string {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  getFaqs() {
    this.faqs = mockedFaqs;
  }

  toggleSelectedCategory(faq: Faq) {
    faq.selected = !faq.selected;
    this.updateUrl(faq);
  }

  toggleSelectedQuestion(faqQuestion: FaqQuestion, category: Faq) {
    faqQuestion.selected = !faqQuestion.selected;
    this.updateUrl(category, faqQuestion);
  }

  private updateUrl(category: Faq, question?: FaqQuestion): void {
    const categorySlug = this.createSlug(category.category);
    const fragment = question?.selected
      ? `${categorySlug}--${this.createSlug(question.question)}`
      : categorySlug;

    this.router.navigate([], {
      fragment: fragment,
      replaceUrl: true,
    });
  }

  toggleConctactUsPanel() {
    this.showContactUsPanel = !this.showContactUsPanel;
    this.messageText = '';
  }

  sendFeedback(text: string) {
    // all'interno di text c'è il contenuto del messaggio
    this.gmailService.sendEmailToSupport(text).subscribe({
      next: (success) => {
        if (success) {
          this.toggleConctactUsPanel();
        }
      },
      error: (error) => {
        console.error('Error sending feedback email:', error);
        this.errorPanelService.showErrorSnackBar(
          "Errore nell'invio della mail"
        );
        this.toggleConctactUsPanel();
      },
    });
  }
}
